import { NavLink } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { NAV_SECTIONS } from '../../constants/navigation';
import { cn } from '../../utils/cn';
import { Icon } from '../ui/Icon';
import { closeMobileSidebar } from '../../store/slices/uiSlice';

export default function Sidebar() {
  const dispatch = useDispatch();
  const mobileOpen = useSelector((s) => s.ui.mobileSidebarOpen);

  return (
    <>
      {/* Mobile backdrop */}
      {mobileOpen && (
        <div
          className="fixed inset-0 z-30 bg-neutral-900/50 lg:hidden"
          onClick={() => dispatch(closeMobileSidebar())}
        />
      )}

      <aside
        className={cn(
          'fixed top-0 left-0 z-40 h-screen w-64 flex-shrink-0 border-r border-neutral-200 bg-white transition-transform lg:sticky lg:translate-x-0',
          mobileOpen ? 'translate-x-0' : '-translate-x-full',
        )}
      >
        <div className="flex h-full flex-col">
          {/* Logo */}
          <div className="flex h-16 items-center gap-2.5 border-b border-neutral-200 px-5">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-600 to-primary-800 text-white">
              <Icon name="trophy" className="h-5 w-5" />
            </div>
            <div>
              <p className="text-sm font-semibold text-neutral-900 leading-tight">Rule Engine</p>
              <p className="text-[10px] text-neutral-500 leading-tight">Gamification Yönetimi</p>
            </div>
          </div>

          {/* Nav */}
          <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-5">
            {NAV_SECTIONS.map((section) => (
              <div key={section.label}>
                <p className="px-3 pb-1.5 text-[10px] font-semibold uppercase tracking-wider text-neutral-400">
                  {section.label}
                </p>
                <ul className="space-y-0.5">
                  {section.items.map((item) => (
                    <li key={item.to}>
                      <NavLink
                        to={item.to}
                        onClick={() => dispatch(closeMobileSidebar())}
                        className={({ isActive }) =>
                          cn(
                            'flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                            isActive
                              ? 'bg-primary-50 text-primary-700'
                              : 'text-neutral-600 hover:bg-neutral-100 hover:text-neutral-900',
                          )
                        }
                      >
                        <Icon name={item.icon} className="h-4 w-4" />
                        <span>{item.label}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </nav>

          {/* Footer — version */}
          <div className="border-t border-neutral-200 px-5 py-3">
            <div className="flex items-center justify-between text-[10px] text-neutral-400">
              <span>v0.1.0</span>
              <span className="inline-flex items-center gap-1">
                <span className="h-1.5 w-1.5 rounded-full bg-success-500" />
                Bağlı
              </span>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
}
